module.exports = __webpack_public_path__ + "fecd769cbb48fc59ea100cfc1e6d8cac.jpg";